import React, { Component } from 'react'
import MergeConnectApp from "./merge.js";
import session from '../../utils/session'
import { Card, CardText } from 'material-ui/Card'


import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'

import Snackbar from 'material-ui/Snackbar'
import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'
import Dialog from 'material-ui/Dialog'
import FullStarIcon from 'material-ui/svg-icons/toggle/star'
import RaisedButton from 'material-ui/RaisedButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import { yellow500 } from 'material-ui/styles/colors'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import { Grid } from "@material-ui/core";

import StarIcon from 'material-ui/svg-icons/toggle/star-border'
import CloseIcon from 'material-ui/svg-icons/navigation/close'
import CheckCircleIcon from 'material-ui/svg-icons/action/check-circle'

import { getAllApps, setAppAsDefault } from '../../reducers/apps/resources'
import { getLists, saveMailChimpData } from '../../reducers/mailchimp/resources'
import {
  getAccessToken,
  removeUserIntegration,
  integrateCalendly,
} from '../../reducers/integrations/resources'

import { setUserAppSettingsState } from '../../reducers/integrations/actions'

import CronofyCalendarDialog from '../dialogs/cronofy-calendar-dialog'

import { convertQueryToObj } from '../../utils/object'
import mixpanel from '../../utils/mixpanel'

import _ from 'lodash'
import moment from 'moment'

import './index.css'
import config from '../../config'

class MergeIntergrations extends Component {
  componentWillMount = async () => {
    const path = this.props.match.path

    this.setState({
      showSnackBar: false,
      snackBarMessage: '',
      integrationApps: {},
      apps: [],
      authURL: '',
      showMCDialog: false,
      mcLists: [],
      mcList: {},
      mcData: {},
      integApp: null,
      showRemoveDialog: false,
      showCalendlyDialog: false,
      calendlyLink: '',
      groups: [],
      calendars: [],
      isIntegrations: !path.includes('/account-setup'),
      showCronofyDialog: false,
      showLeverSuccessDialog: false,
      showMergeSuccessDialog: false,
    })
  }

  componentDidMount = () => {
    let query = this.props.location.search

    ;(async () => {
      await this.loadApps()

      if (!query) {
        return
      }

      query = convertQueryToObj(query.slice(1))
      const { type } = JSON.parse(decodeURIComponent(query.state))

      try {
        let tokenData = await getAccessToken(
          `code=${query.code}&type=${type}&path=${this.state.isIntegrations}`,
        )
        if (type === 'mailchimp') {
          const { access_token, dc } = tokenData.data

          const lists = await getLists({ access_token, dc })

          this.setState({
            mcData: tokenData.data,
            showMCDialog: true,
            mcLists: lists.data,
          })
        } else if (type.startsWith('cronofy')) {
          tokenData = tokenData.data

          this.setState({
            cronofyData: tokenData,
            calendars: tokenData.calendars,
            showCronofyDialog: true,
          })
        } else if (type.startsWith('lever')) {
          tokenData = tokenData.data
          if (tokenData.is_error) {
            throw Error()
          } else {
            this.setState({
              showLeverSuccessDialog: true,
            })
          }
        } else if (type.startsWith('merge')){
          //open the dialog
          console.log('open the merge success dialog')
        }else {
          throw Error()
        }
      } catch (error) {
        this.setState({
          showSnackBar: true,
          snackBarMessage: 'There was a problem with the integration.',
        })
      }
    })()
  }

  loadApps = async () => {
    let integrationApps = await getAllApps(this.state.isIntegrations)
    integrationApps = integrationApps.data

    this.setState({
      integrationApps,
      groups: integrationApps.groups,
    })
  }

  closeSnackbar = () => {
    this.setState({
      showSnackBar: false,
      snackBarMessage: '',
    })
  }

  closeMCDialog = () => {
    this.setState({
      showMCDialog: false,
      mcLists: [],
      mcList: {},
    })
  }

  authApp = (userApp) => (event) => {
    event.preventDefault()

    window.open(this.state.authURL)
  }

  selectRows = (rowIndex) => {
    const mcList = this.state.mcLists[rowIndex]

    this.setState({ mcList })
  }

  saveMCData = async () => {
    const { mcData, mcList } = this.state

    mixpanel.track('integrations:save mailchimp data')

    if (_.isEmpty(mcList)) {
      return this.setState({
        showSnackBar: true,
        snackBarMessage: 'No list has been selected.',
      })
    }

    const data = JSON.stringify({
      ...mcData,
      list_id: mcList.id,
    })

    try {
      await saveMailChimpData({ data })

      this.loadApps()

      this.closeMCDialog()
    } catch (error) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: 'There was a problem with the integration.',
      })
    }
  }

  removeIntegration = async () => {
    const { integApp } = this.state
    const { user_id: userId, company_id: companyId, app_id: appId } = integApp

    mixpanel.track('integrations:remove integration')

    let data = { appId }
    if (userId) {
      data = { ...data, userId }
    }
    if (companyId) {
      data = { ...data, companyId }
    }

    try {
      await removeUserIntegration({
        userId,
        companyId,
        appId,
      })

      await this.loadApps()
      this.setState({ showRemoveDialog: false })
    } catch (error) {
      this.setState({
        showRemoveDialog: false,
        showSnackBar: true,
        snackBarMessage: error.message,
      })
    }
  }

  integrateCalendly = async () => {
    let { calendlyLink } = this.state

    mixpanel.track('integrations:integrate calendly')

    if (
      !calendlyLink.startsWith('https://') &&
      !calendlyLink.startsWith('http://')
    ) {
      calendlyLink = `https://${calendlyLink}`
    }

    if (!calendlyLink.startsWith('https://calendly.com/')) {
      return this.setState({
        showCalendlyDialog: false,
        showSnackBar: true,
        snackBarMessage: 'Given link is not a valid Calendly link.',
        calendlyLink: '',
      })
    }

    await integrateCalendly({
      type: 'calendly',
      data: JSON.stringify({ calendlyLink }),
    })

    this.setState({ showCalendlyDialog: false })
    await this.loadApps()
  }

  setAppDefault = (userApp, group) => async () => {
    try {
      mixpanel.track('integration:set default', { data: { userApp, group } })

      await setAppAsDefault({ appDetails: JSON.stringify(userApp), group })

      this.setState({
        showSnackBar: true,
        snackBarMessage: 'App has been set as default',
      })
      await this.loadApps()
    } catch (error) {
      this.setState({
        showSnackBar: true,
        snackBarMessage: error.message,
      })
    }
  }

  setIntegrationState = (data) => {
    this.setState({ ...data })
  }

  render = () => {
    const { integrationApps, integApp } = this.state

    const groups = this.state.groups.map((group) => {
      const { apps: grpApps, label } = group

      if(label !=='Ats hris'){
        return
      }

      const apps = grpApps.map((app) => {
        let statusClass = 'appStatus'
        let status = 'Not Connected'
        let removeBtn
        let defaultBtn
        const userApp = _.find(integrationApps.companyApps, { app_id: app.id })
        if (userApp) {
          statusClass = 'integrated'
          status = 'Connected'
          removeBtn = (
            <FloatingActionButton
              secondary={true}
              mini={true}
              className="remove-int-btn"
              style={{ width: 30, height: 30 }}
              onClick={() =>
                this.setState({ showRemoveDialog: true, integApp: userApp })
              }
            >
              <CloseIcon style={{ height: 30 }} />
            </FloatingActionButton>
          )

          let defaultEl = (
            <span className="default-label">
              <CheckCircleIcon
                style={{
                  width: 15,
                  height: 15,
                  marginRight: 3,
                  color: 'white',
                }}
              />{' '}
              Default
            </span>
          )
          if (!userApp.is_default) {
            defaultEl = (
              <RaisedButton
                label="Set As Default"
                onClick={this.setAppDefault(userApp, group.group)}
              />
            )
          }

          defaultBtn = (
            <Row>
              <Col xs={12}>
                <div className="default-btn">{defaultEl}</div>
              </Col>
            </Row>
          )

          if (['lever','merge'].includes(app.type.toLowerCase())) {
            defaultBtn = ''
          }
        }

        let styles
        if (app.style) {
          const { imgStyle } = JSON.parse(app.style)
          styles = imgStyle
        }


        //the default Cards
        let paperApp = (
          <Paper style={{ borderRadius: '10px' }} className="app" key={app.id}>
            {removeBtn}
            <Row>
              <Col xs={12}>
                <div className="alignCenter logoContainer">
                  <img
                    src={`${config.api.host}/api/v1/files/app-logo/${app.image}`}
                    alt={app.name}
                    className="appLogo"
                    style={styles}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Divider />
                <div className="alignCenter">
                  <h4 className="appName">{app.name}</h4>
                  <span className="appStatus">Status: </span>
                  <span className={statusClass}>{status}</span>
                </div>
              </Col>
            </Row>
            {defaultBtn}
          </Paper>
        )

        //modify the card for merge
        if(userApp && app.type==='merge'){
            let appData = JSON.parse(userApp.data)
            paperApp = (
              <Paper className="app" key={app.id}>
                {removeBtn}
                <Row>
                  <Col xs={12}>
                    <div className="alignCenter">
                      <img
                        src={`${config.api.host}/api/v1/files/app-logo/${app.image}`}
                        alt={app.name}
                        className="appLogoSmall"
                        style={styles}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="alignCenter logoContainer" style={{maxHeight:'100px'}}>
                      <img
                        src={`${appData.integration.image}`}
                        alt={app.name}
                        className="appLogo"
                        style={styles}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Divider />
                    <div className="alignCenter">
                      <h4 className="appName">{appData.integration.name}</h4>
                      <span className="appStatus">Status: </span>
                      <span className={statusClass}>{status}</span>
                    </div>
                  </Col>
                </Row>
                {defaultBtn}
              </Paper>
            )
        }

        //this would be the rendering part, special condition for merge
        if (!userApp) {
          if (app.type === 'calendly') {
            paperApp = (
              <div></div>
            )
          } else {

            if(app.type==='merge'){
              paperApp = (
                <MergeConnectApp 
                  card={paperApp} 
                  userId={session.get('userData').id}
                  connected={false}
                  successCallback={
                    async ()=>{
                      //refresh cards
                      this.setState({showMergeSuccessDialog:true})
                      await this.loadApps()
                    }
                  }
                />
              )
            }else{
              paperApp = (
                <a href={app.url || '#'} key={app.id}>
                  {paperApp}
                </a>
              )
            }
          }
        }

        return paperApp
      })

      return (
        <div key={group.group} style={{ marginBottom: 20 }}>
          <Row>
            <Col xs={12}>
              <div className="appsContainer">{apps}</div>
            </Col>
          </Row>
        </div>
      )
    })

    const mcLists = []
    this.state.mcLists.forEach((mcList) => {
      const rating = []
      for (var i = 0; i < mcList.list_rating; i++) {
        rating.push(<FullStarIcon color={yellow500} />)
      }
      for (var i = 0; i < 5 - mcList.list_rating; i++) {
        rating.push(<StarIcon />)
      }

      mcLists.push(
        <TableRow key={mcList.id} selected={this.state.mcList.id === mcList.id}>
          <TableRowColumn>{mcList.name}</TableRowColumn>
          <TableRowColumn>{mcList.member_count}</TableRowColumn>
          <TableRowColumn>{rating}</TableRowColumn>
          <TableRowColumn>
            {moment(mcList.date_created).format('MMM DD YYYY hh:mm A')}
          </TableRowColumn>
        </TableRow>,
      )
    })

    const actions = [
      <RaisedButton
        label="Cancel"
        onClick={this.closeMCDialog}
        style={{ marginRight: '5px' }}
      />,
      <RaisedButton label="Submit" primary={true} onClick={this.saveMCData} />,
    ]

    const removeActions = [
      <RaisedButton
        label="No"
        secondary={true}
        onClick={() => this.setState({ showRemoveDialog: false })}
        style={{ marginRight: '5px' }}
      />,
      <RaisedButton
        label="Yes"
        primary={true}
        onClick={this.removeIntegration}
      />,
    ]

    const successATSActions = [
      <RaisedButton
        label="OK"
        primary={true}
        onClick={async () => {
          await this.loadApps()
          this.setState({ showLeverSuccessDialog: false,showMergeSuccessDialog:false })
        }}
        style={{ marginRight: '5px' }}
      />,
    ]

    const calendlyActions = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onClick={() => this.setState({ showCalendlyDialog: false })}
        style={{ marginRight: '5px' }}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        onClick={this.integrateCalendly}
      />,
    ]

    let nextBtn
    if (!this.state.isIntegrations) {
      nextBtn = (
        <Row style={{ margin: '20px 10px 0' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <RaisedButton
                label="Next"
                primary={true}
                onClick={() => {
                  this.props.history.replace('/account-setup/send-first-sms')
                }}
              />
            </div>
          </Col>
        </Row>
      )
    }

    let styles = {
      gridFluid: {
        height: '100%',
        backgroundColor: '#FBFBFB',
        overflowY: 'auto',
        paddingBottom: '150px',
      }
    }

    return (
      <Grid fluid style={styles.gridFluid} >
        <div>
          <div style={{ height: '80px', backgroundColor: '#F5F5F5'}}>
              <div style={{ height: '100%', width: '90%', padding: '20px', margin: '0 auto'}}>
                  <h2 style={{ margin: 0 }}>Integrations</h2>
              </div>
          </div> 
          <div className={"integration-setting-content"}>
            <div>
              <Snackbar
                open={this.state.showSnackBar}
                message={this.state.snackBarMessage}
                autoHideDuration={4000}
                onRequestClose={this.closeSnackbar}
              />
              {nextBtn}
              <Row>
                <Col xs={12}>
                  <div
                    className="tour-integrations-select"
                    style={{ margin: '20px 10px 0' }}
                  >
                    {groups}
                  </div>
                </Col>
              </Row>
              <CronofyCalendarDialog
                openDialog={this.state.showCronofyDialog}
                calendars={this.state.calendars}
                cronofyData={this.state.cronofyData}
                setIntegrationState={this.setIntegrationState}
                loadApps={this.loadApps}
              />
              <Dialog
                title="Integration Success"
                actions={successATSActions}
                modal={false}
                open={this.state.showLeverSuccessDialog}
                autoScrollBodyContent={true}
              >
                <h4>You've successfully connected your Lever account.</h4>
              </Dialog>
              <Dialog
                title="Scyning Started"
                actions={successATSActions}
                modal={false}
                open={this.state.showMergeSuccessDialog}
                autoScrollBodyContent={true}
              >
                <h4>We're now doing the initial sync from your account into GoHire. This might take some time; We'll send you an email once complete.</h4>
              </Dialog>

              <Dialog
                title="Select MailChimp List"
                actions={actions}
                modal={false}
                open={this.state.showMCDialog}
                onRequestClose={this.closeMCDialog}
                autoScrollBodyContent={true}
              >
                <Row>
                  <Col xs={12}>
                    <Table
                      onRowSelection={this.selectRows}
                      style={{ tableLayout: 'auto' }}
                      fixedHeader={false}
                    >
                      <TableHeader displaySelectAll={false}>
                        <TableRow>
                          <TableHeaderColumn>Name</TableHeaderColumn>
                          <TableHeaderColumn>Member Count</TableHeaderColumn>
                          <TableHeaderColumn>Rating</TableHeaderColumn>
                          <TableHeaderColumn>Date Created</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        displayRowCheckbox={true}
                        deselectOnClickaway={false}
                      >
                        {mcLists}
                      </TableBody>
                    </Table>
                  </Col>
                </Row>
              </Dialog>
              <Dialog
                title="Remove integration"
                actions={removeActions}
                modal={false}
                open={this.state.showRemoveDialog}
                onRequestClose={() =>
                  this.setState({ showRemoveDialog: false, integApp: null })
                }
                autoScrollBodyContent={true}
              >
                <h4>
                  Are you sure you want to remove {integApp ? integApp.app.name : ''}{' '}
                  integration?
                </h4>
                {this.state.integApp && this.state.integApp.app.type === 'merge' ? 
                  <Card containerStyle={{padding:'5px'}} style={{background:'#ff9800'}}>
                    <CardText >
                      <strong>Caution</strong>: If you want to reintegrate, you will have to go through the initial sync sequence again. 
                    </CardText>
                  </Card>
                : ''}
              </Dialog>
              <Dialog
                title="Calendly Integration"
                actions={calendlyActions}
                modal={false}
                open={this.state.showCalendlyDialog}
                onRequestClose={() => this.setState({ showCalendlyDialog: false })}
                autoScrollBodyContent={true}
              >
                <h4>
                  To integrate your calendar using calendly, we need your Calendly
                  link.
                </h4>
                <h4>Please enter your Calendly link on the field below.</h4>
                <Row>
                  <Col xs={6}>
                    <TextField
                      hintText="https://calendly.com/GoHire"
                      onChange={(event, value) =>
                        this.setState({ calendlyLink: value })
                      }
                    />
                  </Col>
                </Row>
              </Dialog>
            </div>
          </div>
        </div>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUserAppSettingsState(data) {
      dispatch(setUserAppSettingsState(data))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MergeIntergrations)
